import { useIsFeatureFlagOn } from "@/domain/_shared/feature-flag/hooks/use-is-feature-flag-on";
import { MUNICIPAL_PROPERTY_CATALOG_PATH } from "@/domain/municipal-property/routes/municipal-property-catalog-path";
import { MUNICIPAL_PROPERTY_REGISTER_LIST_PATH } from "@/domain/municipal-property/routes/municipal-property-register-list-path";
import { MUNICIPAL_PROPERTY_CONSUMPTION_FEATURE_FLAG_ID, MUNICIPAL_PROPERTY_FEATURE_FLAG_ID } from "@ark/shared";

interface MunicipalPropertySections {
  isCatalogOn: boolean;
  isConsumptionOn: boolean;
  isLoading: boolean;
  defaultSectionPath: string | null;
}

export function useMunicipalPropertySections(): MunicipalPropertySections {
  const catalog: ReturnType<typeof useIsFeatureFlagOn> = useIsFeatureFlagOn({
    flag: MUNICIPAL_PROPERTY_FEATURE_FLAG_ID,
    isDevelopmentBypassAllowed: false,
  });
  const consumption: ReturnType<typeof useIsFeatureFlagOn> = useIsFeatureFlagOn({
    flag: MUNICIPAL_PROPERTY_CONSUMPTION_FEATURE_FLAG_ID,
    isDevelopmentBypassAllowed: false,
  });
  let defaultSectionPath: string | null = null;
  if (catalog.isOn) defaultSectionPath = MUNICIPAL_PROPERTY_CATALOG_PATH;
  else if (consumption.isOn) defaultSectionPath = MUNICIPAL_PROPERTY_REGISTER_LIST_PATH;
  return {
    isCatalogOn: catalog.isOn,
    isConsumptionOn: consumption.isOn,
    isLoading: catalog.isLoading || consumption.isLoading,
    defaultSectionPath,
  };
}
